import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import App from "./App.tsx";
import "./index.css";
import { GlobalErrorBoundary } from "@/components/GlobalErrorBoundary";
import { installGlobalErrorHandlers } from "@/lib/errorLogger";
import { installToastErrorLogging } from "@/lib/errorToast";
import { registerServiceWorker, initInstallPromptCapture } from "@/pwa/registerSW";

installGlobalErrorHandlers();
installToastErrorLogging();
initInstallPromptCapture();
if (typeof window !== "undefined") {
  window.addEventListener("load", () => {
    void registerServiceWorker();
  });
}


// Force Light Mode globally (dark mode is not supported in this app)
try {
  const root = document.documentElement;
  root.classList.remove("dark");
  root.classList.add("light");
  localStorage.removeItem("theme");
  localStorage.removeItem("resolvedTheme");
  localStorage.setItem("theme", "light");
} catch {
  // no-op
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <GlobalErrorBoundary>
          <App />
        </GlobalErrorBoundary>
      </TooltipProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

